// extracted by mini-css-extract-plugin
export var computer = "style-module--computer--d8182";
export var person = "style-module--person--f338d";
export var structure = "style-module--structure--30a51";